// Gemensamma stilar för sidorna i modulen Inköp. Följer temat och regeln att
// guldfyllning bara används för handlingar.
import React from 'react';
import { TEMA } from '../theme';

export const sida: React.CSSProperties = { fontFamily: "'Inter', sans-serif", color: TEMA.inkSoft };
export const rubrik: React.CSSProperties = { fontFamily: "'Fraunces', serif", fontSize: '26px', color: TEMA.ink, margin: 0, fontWeight: 400 };
export const underrubrik: React.CSSProperties = { fontFamily: "'Fraunces', serif", fontSize: '17px', color: TEMA.ink, margin: '0 0 14px', fontWeight: 400 };
export const etikett: React.CSSProperties = { fontFamily: "'IBM Plex Mono', monospace", fontSize: '11px', color: TEMA.inkFaint, display: 'block', marginBottom: '6px' };
export const kort: React.CSSProperties = { background: TEMA.bgPanel, border: `1px solid ${TEMA.border}`, borderRadius: '4px', padding: '18px 20px', marginBottom: '16px' };
export const fält: React.CSSProperties = {
  width: '100%', padding: '8px 10px', fontSize: '14px', fontFamily: "'Inter', sans-serif",
  borderRadius: '2px', border: `1px solid ${TEMA.border}`, background: TEMA.bg, color: TEMA.ink,
  boxSizing: 'border-box', outline: 'none', minWidth: 0,
};
export const knapp: React.CSSProperties = {
  padding: '8px 16px', borderRadius: '2px', background: TEMA.accent, color: TEMA.onAccent,
  fontFamily: "'Inter', sans-serif", fontSize: '13px', fontWeight: 500, border: `1px solid ${TEMA.accent}`, cursor: 'pointer',
};
export const knappSpök: React.CSSProperties = {
  padding: '8px 14px', borderRadius: '2px', background: 'transparent', color: TEMA.inkSoft,
  fontFamily: "'Inter', sans-serif", fontSize: '13px', border: `1px solid ${TEMA.border}`, cursor: 'pointer',
};
export const länkknapp: React.CSSProperties = {
  background: 'none', border: 'none', padding: 0, color: TEMA.accent, cursor: 'pointer',
  fontFamily: "'Inter', sans-serif", fontSize: '13px',
};
export const tabell: React.CSSProperties = { width: '100%', borderCollapse: 'collapse', fontSize: '13px' };
export const th: React.CSSProperties = {
  textAlign: 'left', fontWeight: 400, color: TEMA.inkFaint, fontSize: '11.5px', padding: '6px 8px',
  borderBottom: `1px solid ${TEMA.border}`, whiteSpace: 'nowrap',
};
export const td: React.CSSProperties = { padding: '8px', borderBottom: `1px solid ${TEMA.border}`, color: TEMA.ink, verticalAlign: 'top' };
export const tal: React.CSSProperties = { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' };

export function märke(färg: 'guld' | 'grå' | 'grön' | 'röd'): React.CSSProperties {
  const f = { guld: TEMA.accent, grå: TEMA.inkSoft, grön: TEMA.positive, röd: '#D9695F' }[färg];
  return {
    display: 'inline-block', fontFamily: "'IBM Plex Mono', monospace", fontSize: '11px', padding: '2px 8px',
    borderRadius: '10px', border: `1px solid ${f}`, color: f, whiteSpace: 'nowrap',
    // Märket ska aldrig sträckas ut när texten bredvid bryts på flera rader.
    lineHeight: 1.4, alignSelf: 'center', flexShrink: 0,
  };
}

export const statusfärg = (s: string): 'guld' | 'grå' | 'grön' | 'röd' =>
  s === 'avslutat' || s === 'inlevererat' || s === 'betald' || s === 'inlevererad' ? 'grön'
    : s === 'avbrutet' ? 'röd' : s === 'dialog' || s === 'planerad' ? 'grå' : 'guld';
